import Vue from 'vue'
import store from '../store/index.js'
import config from './config'
import wx from 'weixin-js-sdk'
import md5 from 'js-md5'
import {
  Dialog
} from 'vant'
import common_tb from '../js_tb/common_tb'

Vue.use(wx)

const common = {}

common.config = {}

// 备用域名
// https://api.kumob.cn
// https://jd.kumob.cn

common.jd_host = 'https://api.wapg.cn/jd'
common.jd_union = 'https://api.wapg.cn/jd_union'
common.jd_union_api = 'https://api.wapg.cn/jd_union/api'
// common.jd_union = 'http://api.wapg.cn:10001/jd_union';
// common.jd_union_api = 'http://api.wapg.cn:10001/jd_union/api';

common.union_robot_ts_robot = 'https://api.wapg.cn/union_robot/ts/robot'

common.access_count = 'http://api.wapg.cn/jd_union/h5/'

common.key = 'Waps_jd_MD5key'

common.login = common.jd_host + '/uLogin' //登录
common.order_list = common.jd_host + '/orderListApi' //订单详情接口地址： get|post
common.order_count = common.jd_host + '/orderCount' //订单统计接口：
common.order_log_list = common.jd_union + '/jd_order/log_list' //查寻某推广渠道订单列表
common.chart_list = common.jd_host + '/chartList' //趋势图接口：

//以下对接京东联盟接口
//授权开通的接口
common.union_link = common.jd_union_api + '/union_link'
common.goods_query = common.jd_union_api + '/goods_query'
common.coupon_query = common.jd_union_api + '/coupon_query'
common.seckill_query = common.jd_union_api + '/seckill_query'
common.gift_query = common.jd_union_api + '/gift_query'  //礼金查询 {skuId 或 giftCouponKey,page,size}
common.gift_info = common.jd_union_api + '/gift_info'  //礼金查询 {skuId 或 giftCouponKey}
//6个默认开通接口
common.get_category = common.jd_union_api + '/get_category'
common.jingfen_query = common.jd_union_api + '/jingfen_query'
common.promotion_info_query = common.jd_union_api + '/promotion_info_query'
common.goods_big_field = common.jd_union_api + '/goods_big_field'
common.union_link_common = common.jd_union_api + '/union_link_common'
// common.get_pid = common.jd_union_api + '/get_pid';
common.order_query = common.jd_union_api + '/order_query'
//用户可提款金额接口
common.user_pay_to = common.jd_host + '/UserPayTo'
//用户提款明细接口：
common.user_pay_list = common.jd_host + '/UserPayLists'
//用户提现接口
common.user_submit = common.jd_host + '/userSubmit'
//用户可提款金额接口(多渠道汇总)：
common.user_pay_to_all = common.jd_host + '/UserPayToAll'

//系统配置接口
common.sub_config = common.jd_host + '/SubConfig'
//用户上下级接口
common.user_level = common.jd_host + '/UserLevel'
//转链
common.change_link = common.jd_union + '/link/convert'

common.top_list = common.jd_union_api + '/top_list'
//获取指定skuId的商品信息
common.select_sku_list = common.jd_union_api + '/sku_info_list'

common.category_list = common.jd_union_api + '/category_list?type=2'
common.events_api = common.jd_union_api + '/events'

//一个代理的下级、下下级代理给当前代理所带来的预估提成佣金
// common.pid_level_count_list = common.jd_host + '/PidLevelCountList';
common.pid_level_count_list = common.jd_host + '/PidLevelCountListNew'

//手机注册群主
common.phone_regist = common.jd_host + '/PhoneReg'

//获取验证码
common.get_phone_verify_code = common.jd_union + '/user/verify/send'
//校验验证码
common.check_phone_verify_code = common.jd_union + '/user/verify/check'

common.get_wx_qrurl = common.jd_union + '/wechat/get_qr'

//存储手机号注册成功后的信息（全局变量）
common.gloabl_regist_success_data = null
//扫描二维码后跳转的群主注册页面地址
common.invite_regist_by_qrcode_url = 'http://jd.wapg.cn/#/wx_public_regist'

//修改密码
common.modify_password = common.jd_host + '/UserPmod'

//获取到的微信授权信息（公众号）
common.wx_user_info = null

//存储my页面转码后的地址
common.redirect_url = 'http%3A%2F%2Fjd.wapg.cn%2F%23%2Fmy'
common.redirect_url_hm = 'https%3A%2F%2Fhm.wapg.cn%2Fhema%2F%23%2Fmy'

//用户微信openid同步接口
common.user_openid_sync = common.jd_host + '/UserOidSync'

//获取微信小程序的二维码
common.get_wx_app_qrcode = common.jd_union + '/we_app/qr'
// 万品嗨选
// //小程序appid（静态）
// common.wx_app_id = "wx51546016a2d42464";
// //小程序app_secret（静态）
// common.wx_app_secret = "362c795d83649bffe9981788330a53c1";

// 万品京选
//小程序appid（静态）
common.wx_app_id = 'wx234eda29ae85396d'
//小程序app_secret（静态）
common.wx_app_secret = '3473ef94bd5744bcab601c8756c7f56f'
//小程序二维码图片url（全局）
common.gloabl_wx_mini_qr_img = ''

//微信的openid（全局）
common.gloabl_wx_openid = ''
//获取到的微信小程序授权信息（全局）
common.gloabl_wx_mini_user_info = null
//存储小程序的登录状态（全局）
common.gloabl_wx_mini_login_status = '' //空：原有网页版逻辑；none：小程序未登录；normal：普通会员登录；super：超级会员登录

//通过openid获取服务器端存储的用户信息
common.get_wx_userinfo_old = common.jd_union + '/user/info'
common.get_wx_userinfo = common.jd_union + '/app_user/info'

//存储用户信息到服务器
common.save_user = common.jd_union + '/user/save'
common.save_app_user = common.jd_union + '/app_user/save'

//修改绑定手机号
common.update_phone = common.jd_host + '/PhoneUp'

//订单详情下载xls
common.get_order_by_finish_xls = common.jd_host + '/orderByFinishXls'

//获取提款纪录
common.get_order_by_sumbit = common.jd_host + '/orderBySubmit'

//重置密码
common.reset_password = common.jd_host + '/UserReseP'

//上传图片
common.upload_image = common.jd_host + '/upload'

//提交审核
common.submit_to_examine = common.jd_host + '/JdParentVerify'

//查询提交审核的状态
common.check_examine = common.jd_host + '/ChannelFlag'

//分享的注册成功后，发消息到指定的微信群
common.send_message_to_wechat = common.jd_union + '/wechat_robot/send_helper'
//分享的注册成功后，发消息到指定的微信群（涂色机器人发送消息）
common.send_message_to_wechat_by_ts = common.union_robot_ts_robot + '/message/send_temp/new_user'

//获取粉丝列表
common.get_fans_list = common.jd_union + '/app_user/fans_list'

//邀请下级群主时生成二维码的链接的缓存（全局）
common.gloabl_qrcode_link = ''

//小程序的二维码图片地址（全局）
common.gloabl_mini_qrcode_link = ''

//通过手机号获取对应的账号列表
common.get_account_list_by_phone = common.jd_host + '/PhoneUser'
//账号列表缓存（全局）
common.gloabl_account_list = [],

  //自动登录接口
  common.auto_login = common.jd_host + '/uLoginPwd'

//缓存从文章详情返回的状态（全局）
common.is_from_article_content = ''

//获取分享素材数据
// common.get_share_datas = common.jd_union + "/mini_app/share_data.json";
common.get_share_datas = common.jd_union + '/config/share_data'

//获取群编号
common.get_new_channel_name = common.jd_union + '/app_user/max_channel'

//收入统计
common.order_count_new = common.jd_host + '/orderCountNew'

//群下级人数
common.level_count_total = common.jd_host + '/LeveCount'

//群下级人数及对应收入
common.level_count_data = common.jd_host + '/LeveCountData'

//提款操作来自于数据页面（全局）
common.pay_from_data_page = false

//指定日期预估总收入列表
common.get_everyday_count_list = common.jd_host + '/DayCount'
//指定日期预估推广收入列表
common.get_everyday_user_count_list = common.jd_host + '/UserDayCount'

//预估佣金 私有比例
common.commissionRate_pir = 0.525

//往公众号发消息
common.send_message_to_public = common.jd_union + '/wechat/send_account'

//获取用户活跃值
common.get_group_active_value = common.jd_host + '/UserActiveValue'

//获取插屏数据
common.get_pop_datas = common.jd_union + '/config/pop'
//插屏数据（全局）
common.static_pop_datas = null
//首页某个模块的数据（全局）
common.static_home_module_datas = null
//是否透明（全局）
common.transparent = false

common.bg_color = ''
common.font_color = ''
//商品的详细数据的对象
common.static_skuInfo = null
//路由跳转来源（全局）
common.static_scroll_top = 0
//屏幕高
common.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
//屏幕宽
common.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

//获取首页数据
common.get_home_datas = common.jd_union + '/config/home_config'
common.get_home_test_datas = common.jd_union + '/config/home_test' //测试
common.get_home_datas_base = common.jd_union + '/config/'
//获取活动详情
common.get_action_info = common.jd_union + '/union_action/info'
//获取活动列表
common.get_action_list = common.jd_union + '/union_action/list'
//实时官方活动列表
common.get_activity_list = common.jd_union + '/recommend/activity?poolId=[poolId]&activeDate=[yyyyMMdd]'

//活动信息数据（全局）
common.static_action_info_datas = null
//通过参数channel_name获取pid信息
common.get_pid = common.jd_union + '/media/get_pid'
//http://api.wapg.cn/jd_union/media/media_info?channel_name=s002
// common.get_pid=common.jd_union+"/media/media_info";
//获取返现接口数据
common.get_return_cash_data = common.jd_host + '/orderCashList'
//通过Channel_name获取该群中包含的机器人列表
common.get_robot_by_channelname = common.union_robot_ts_robot + '/chat_room/channel_room'
//提交群主要发的消息
common.post_content_to_robot = common.union_robot_ts_robot + '/task_user/save'
//群主提交发送内容列表
common.get_data_list_from_robot = common.union_robot_ts_robot + '/task_user/list'
//群主发送内容删除接口
common.delete_data_from_robot = common.union_robot_ts_robot + '/task_user/delete'
//群主提交内容的未推送列表（全局）
common.global_sku_no_push_data = null
//群主提交内容的已推送列表（全局）
common.global_sku_pushed_data = null
//群主提交内容的全部数据列表（全局）
common.global_sku_all_data = null
//当前群号所在群的助理列表（全局）
common.global_robot_list = null
//助理发品开关
common.robot_on_of = common.union_robot_ts_robot + '/chat_room/room_public_send_status'
//群主发送内容（手动加入助理发品）重新排序
common.robot_sku_list_sort = common.union_robot_ts_robot + '/task_user/order'

//获取用户信息https://api.wapg.cn/jd/uInfo
common.get_user_info = common.jd_host + '/uInfo'
//发送微信用户数据
common.post_wx_user_data = common.jd_host + '/WxUserData'

//获取活动中奖励信息的状态数据（https://api.wapg.cn/jd/UserPointsData）
common.get_user_active_status = common.jd_host + '/UserPointsData'
//提交领取对应的奖励（https://api.wapg.cn/jd/UserPointsSubmit）
common.submit_to_get_award = common.jd_host + '/UserPointsSubmit'

common.show_sku_card_simple_button_model = true
//获取公众号签名（微信js api wx.config接口使用）
common.get_wx_public_signature = common.jd_union + '/wechat/ticket'
//获取发品列表 https://api.wapg.cn/union_robot/ts/robot/task/list
common.robot_task_list_url = common.union_robot_ts_robot + '/task/list'
//保存短链接口
common.save_short_url = common.jd_union + '/url/save'

common.getUrlKey = function (name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

common.getUrlKey2 = function (url, name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20')) || null
}

common.getUrlParams = function () {
  let params = ''
  if (location.href && location.href.indexOf('?') > -1) {
    let url = location.href
    params = url.substring(url.indexOf('?') + 1, url.length)
  }
  return params
}

common.dateAdd = function (interval, number, date) {
  switch (interval) {
    case 'y ': {
      date.setFullYear(date.getFullYear() + number)
      return date
    }
    case 'q ': {
      date.setMonth(date.getMonth() + number * 3)
      return date
    }
    case 'M ': {
      date.setMonth(date.getMonth() + number)
      return date
    }
    case 'w ': {
      date.setDate(date.getDate() + number * 7)
      return date
    }
    case 'd ': {
      date.setDate(date.getDate() + number)
      return date
    }
    case 'h ': {
      date.setHours(date.getHours() + number)
      return date
    }
    case 'm ': {
      date.setMinutes(date.getMinutes() + number)
      return date
    }
    case 's ': {
      date.setSeconds(date.getSeconds() + number)
      return date
    }
    default: {
      date.setDate(date.getDate() + number)
      return date
    }
  }
}

common.getDateFromStr = function (str) {
  try {
    // str=str.replace('年','-').replace('月','-').replace('日','-');
    let reg = '(\\d{4})[\u4e00-\u9fa5]*(\\d{2})[\u4e00-\u9fa5]*(\\d{2})[\u4e00-\u9fa5]*'
    let r2 = new RegExp(reg)
    let regList = r2.exec(str)
    str = regList[1] + '-' + regList[2] + '-' + regList[3]
  } catch (e) {
    return ''
  }
  return str
}

// common.dateFmt = function (fmt, date) { //author: meizz
// //     var o = {
// //         "M+": date.getMonth() + 1,                 //月份
// //         "d+": date.getDate(),                    //日
// //         "h+": date.getHours(),                   //小时
// //         "m+": date.getMinutes(),                 //分
// //         "s+": date.getSeconds(),                 //秒
// //         "q+": Math.floor((date.getMonth() + 3) / 3), //季度
// //         "S": date.getMilliseconds()             //毫秒
// //     };
// //     if (/(y+)/.test(fmt))
// //         fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
// //     for (var k in o)
// //         if (new RegExp("(" + k + ")").test(fmt))
// //             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
// //     return fmt;
// // };

common.dateFmt = function (fmt, date) { //author: meizz
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  return fmt
}

common.dateFormat = function (ns) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(ns)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate() + 1
  var h = time.getHours() + 1
  var mm = time.getMinutes() + 1
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm)
}

function add0 (m) {
  return m < 10 ? '0' + m : m
}

common.stringToDate = function (string) {
  if (string.indexOf('-') > 0) {
    string = string.replace(/-/g, '/')
  }
  return new Date(string)
}

common.getVCodeStr = function (vcode) {
  // -1：未知,
  // 2.无效-拆单,
  // 3.无效-取消,
  // 4.无效-京东帮帮主订单,
  // 5.无效-账号异常,
  // 6.无效-赠品类目不返佣,
  // 7.无效-校园订单,
  // 8.无效-企业订单,
  // 9.无效-团购订单,
  // 10.无效-开增值税专用发票订单,
  // 11.无效-乡村推广员下单,
  // 12.无效-自己推广自己下单,
  // 13.无效-违规订单,
  // 14.无效-来源与备案网址不符,
  // 15.待付款,
  // 16.已付款,
  // 17.已完成,
  // 18.已结算
  let str = ''
  if (vcode) {
    vcode = Number(vcode)
    switch (vcode) {
      case -1:
        str = '未知'
        break
      case 2:
        str = '无效-拆单'
        break
      case 3:
        str = '无效-取消'
        break
      case 4:
        str = '无效-京东帮帮主订单'
        break
      case 5:
        str = '无效-账号异常'
        break

      case 6:
        str = '无效-赠品类目不返佣'
        break

      case 7:
        str = '无效-校园订单'
        break

      case 8:
        str = '无效-企业订单'
        break

      case 9:
        str = '无效-团购订单'
        break

      case 10:
        str = '无效-开增值税专用发票订单'
        break

      case 11:
        str = '无效-乡村推广员下单'
        break

      case 12:
        str = '无效-自己推广自己下单'
        break

      case 13:
        str = '无效-违规订单'
        break

      case 14:
        str = '无效-来源与备案网址不符'
        break

      case 15:
        str = '待付款'
        break

      case 16:
        str = '已付款'
        break

      case 17:
        str = '已完成'
        break

      case 18:
        str = '已结算'
        break
    }
  }
  return str
}

common.getRandom = function () {
  // return Math.floor(Math.random()*16);
  return new Date().getTime()
}

//js对象复制，排除空值和-1的
common.copyObj = function (obj) {
  let _data = {}
  for (let k in obj) {
    let keyType = typeof (obj[k])
    let keyValue = obj[k]

    // let isCopy = false;
    if (keyType === 'number' && keyValue > -1) {
      // isCopy = true;
      _data[k] = parseInt(keyValue)
    }
    if (keyType === 'string' && keyValue && keyValue.length > 0) {
      // isCopy = true;
      _data[k] = keyValue
    }
    if (keyType === 'object') {
      _data[k] = keyValue
    }
    if (keyType === 'boolean') {
      _data[k] = keyValue
    }
  }
  return _data
}

common.mediaId_70637 = '70637'

common.getAppKeyInfo = function (media_id) {
  let appkey = ''
  let secretkey = ''
  switch (media_id) {
    case common.mediaId_70637: {
      appkey = '7c7c7925bffcfd7cd3b0b9a490e586ff'
      secretkey = 'c2c9e4ed9f1e4786bd74e50ae341f613'
      break
    }
    case '70445': {
      appkey = '5ff9a100f38159cea62c76c0dc8d1d5b'
      secretkey = 'c6b5c507c77b443b9512acf2ef0d7513'
      break
    }
    case '66450': {
      appkey = 'bca3331f94c54150e613ffe68d31bc50'
      secretkey = '0f5176ea9dd547c79bf416eab93d8d1f'
      break
    }
    case '64151': {
      appkey = '733c0c9c35f344fc5071172c4bc148fe'
      secretkey = '96bd02a7de4b425bb724fb56e7c66a84'
      break
    }
    case '63665': {
      appkey = '733c0c9c35f344fc5071172c4bc148fe'
      secretkey = '96bd02a7de4b425bb724fb56e7c66a84'
      break
    }
  }

  let appKeyInfo = {
    app_key: appkey,
    app_secret: secretkey,
  }
  return appKeyInfo
}

//自动找出合适的卷链接
common.autoFindCoupon = function (couponList) {
  let _bestIndex = -1
  let _maxDiscountIndex = -1
  if (couponList.length === 1) {

    return couponList[0]
  }
  if (couponList.length > 0) {
    let _maxDiscount = 0
    let nowTamp = Date.parse(new Date())

    for (let i = 0; i < couponList.length; i++) {
      let _coupon = couponList[i]
      let isBest = _coupon.isBest
      let discount = _coupon.discount //券面额
      let getEndTime = _coupon.getEndTime
      if (getEndTime > nowTamp) {
        if (discount > _maxDiscount) {
          _maxDiscount = discount
          _maxDiscountIndex = i
        }
        if (isBest === 1) {
          _bestIndex = i
        }
      }
    }
  }
  let selectIndex = -1
  //有bast的情况下优先选best,没有的时候选券面值最大的
  if (_bestIndex > -1) {
    selectIndex = _bestIndex
  } else if (_maxDiscountIndex > -1) {
    selectIndex = _maxDiscountIndex
  }
  if (selectIndex > -1) {
    let _coupon = couponList[selectIndex]
    return _coupon
  } else {
    return null
  }
}

//自动找出合适的卷链接
common.autoFindCoupon2 = function (couponList) {
  let _bestIndex = -1
  if (couponList.length === 1) {

    return couponList[0]
  }

  if (couponList.length > 0) {

    for (let i = 0; i < couponList.length; i++) {
      let _coupon = couponList[i]
      let isBest = _coupon.isBest
      if (isBest === 1) {
        _bestIndex = i
        break
      }
    }
  }
  let selectIndex = -1

  if (_bestIndex > -1) {
    selectIndex = _bestIndex
  }
  if (selectIndex > -1) {
    let _coupon = couponList[selectIndex]
    return _coupon
  } else {
    return null
  }
}

/**
 * 判断手机号码有效
 * @param phone_number
 * @return {boolean}
 */
common.isPoneAvailable = (phone_number) => {
  var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (!myreg.test(phone_number)) {
    return false
  } else {
    return true
  }
},

  common.isHema = function () {
    let host = window.location.href
    // host = "https://hm.wapg.cn"; //测试
    // host = "https://jd.wapg.cn"; //测试
    // return host.indexOf("hm.wapg.cn") !== -1 || host.indexOf("https://jd.wapg.cn") !== -1;
    return host.indexOf('https://jd.wapg.cn') !== -1
  }

common.hideTabbar = function () {
  // let host = window.location.href;
  // // host = "https://hm.wapg.cn"; //测试
  // // host = "https://jd.wapg.cn"; //测试
  // return host.indexOf("https://jd.wapg.cn") !== -1;
  if (config.project === 'mini') {
    return true
  } else {
    return false
  }
}

//提款时间限制
common.limit_pay_start = 21
common.limit_pay_end = 25

/**
 * 限制的提款时间
 */
common.getLimitPayTime = function () {
  let currentDate = new Date()
  let currentYear = currentDate.getFullYear()
  let currentMonth = currentDate.getMonth()
  //限制时间的起始date
  let startDate = new Date(currentYear, currentMonth, 21)
  //限制时间的结束data
  let endDate = new Date(new Date(currentYear, currentMonth + 1, 1).getTime() - 1)

  //获取缓存的服务器端返回的配置数据中的支付开始时间
  let start_day = store.state.pay_start_day
  if (start_day > 0) {
    common.limit_pay_start = start_day
  }
  if (common.limit_pay_start > 0) {
    startDate = new Date(currentYear, currentMonth, common.limit_pay_start)
  }

  //获取缓存的服务器端返回的配置数据中的支付结束时间
  let end_day = store.state.pay_end_day

  if (end_day > 0) {
    common.limit_pay_end = end_day
  }
  if (common.limit_pay_end > 0) {
    //如果开始时间小于结束时间，则是本月内，否则结束时间为下月日期
    // if(common.limit_pay_start < common.limit_pay_end){
    //     endDate = new Date(new Date(currentYear, currentMonth, common.limit_pay_end + 1).getTime() - 1);
    // }else{
    //     endDate = new Date(new Date(currentYear, currentMonth + 1, common.limit_pay_end + 1).getTime() - 1);
    // }
    endDate = new Date(new Date(currentYear, currentMonth, common.limit_pay_end + 1).getTime() - 1)

  }

  //限制时间的起始日期day
  let startDay = common.dateFmt('dd', startDate)
  //限制时间的结束日期day
  let endDay = common.dateFmt('dd', endDate)

  //测试
  // currentDate = new Date(currentYear, currentMonth, 21);

  //是否可以支付
  let canPay = false
  //如果开始时间小于结束时间，则是本月内，否则结束时间为次月日期，等当前日期为下月时，其实结束时间，也就相当于是本月
  if (common.limit_pay_start < common.limit_pay_end) {
    if (currentDate >= startDate && currentDate <= endDate) {
      canPay = true
    }
  } else {
    //最后一天
    let last_day = new Date(new Date(currentYear, currentMonth + 1, 1).getTime() - 1)

    let first_day = new Date(new Date(currentYear, currentMonth, 1).getTime())

    //从1号到结束日期
    if (currentDate >= first_day && currentDate <= endDate) {
      canPay = true
    }
    //从开始时间，到月末最后1天
    if (currentDate >= startDate && currentDate <= last_day) {
      canPay = true
    }
  }

  return {
    startDate: startDate,
    endDate: endDate,
    startDay: startDay,
    endDay: endDay,
    canPay: canPay
  }
}

//生成群主号，W开头，后边6位随机数
common.createChannelName = function () {
  let random = Math.floor(Math.random() * 1000000)
  let temp_channel_name = random.toString()
  let channel_name = temp_channel_name
  if (temp_channel_name.length < 6) {
    for (let i = 0; i < 6 - temp_channel_name.length; i++) {
      channel_name = '0' + channel_name
    }
  }

  return 'W' + channel_name

}

/**
 * 判断当前在微信浏览器中
 */
common.is_weixn = function () {
  var ua = navigator.userAgent.toLowerCase()

  if (ua.match(/MicroMessenger/i) == 'micromessenger') { //双等号可以判定相等
    // if (ua.match(/MicroMessenger/i) === "micromessenger") { //三等号判断不相等
    // if (ua.match(/MicroMessenger/i) && (ua.match(/MicroMessenger/i)).indexOf("micromessenger") !== -1) {
    return true
  } else {
    return false
  }
}

// common.toFixed2 = function (str) {
//
// }

/**
 * 首页模块被点击
 * @param item 被点击的模块对应的单条数据
 * @param router 路由
 */
common.homeModelClickTo = function (item, router, fn) {
  if (item) {
    //将数据存储到页面缓存
    common.static_home_module_datas = item
    //根据type判断要调用的页面：1打开page，2打开webview
    if (item.type === 1) {
      router.push('home_module_page')
    } else if (item.type === 2) {
      router.push('home_module_webview')
    }
    if (fn) {
      fn
    }
  }
}

/**
 * 打开小程序的指定page
 * @param url 小程序的page的路径
 * @param key url附带的参数key
 * @param param url附带的参数key所对应的值
 */
common.navigateToMiniProgramPage = function (url, key, param) {
  if (common.isBaidu_swan()) {

    if (param) {
      swan.webView.navigateTo({
        url: url + common.serialize({
          [key]: param
        })
      })

      // swan.makePhoneCall({
      //     phoneNumber: '13716321443'
      // })

      // swan.navigateToSmartProgram({
      //     appKey: "4VvF29wlVg61mjRYCp4tY5dqkBgOyoYN",
      //     path: "/pages/union/proxy/proxy?spreadUrl=" + encodeURIComponent("https://u.jd.com/un4QNi")
      // })
    } else {
      swan.webView.navigateTo({
        url: url
      })
    }
  } else {

    if (param) {
      wx.miniProgram.navigateTo({
        url: url + common.serialize({
          _t: Date.now(),
          /* 本次消息的唯一编码，用于微信小程序将处理结果反馈给H5 */
          cmd: 'do',
          /* 业务指令 */
          [key]: param
        })
      })
      // wx.miniProgram.switchTab()
    } else {
      wx.miniProgram.navigateTo({
        url: url
      })
    }
  }
}

common.switchTabMiniProgramPage = function (url) {

  if (common.isBaidu_swan()) {
    swan.webView.switchTab({
      url: url
    })
  } else {
    wx.miniProgram.switchTab({
      url: url
    })
  }
}

/**
 * 打开小程序的指定page(关闭其他所有页面)
 * @param url 小程序的page的路径
 * @param key url附带的参数key
 * @param param url附带的参数key所对应的值
 */
common.reLaunchMiniProgramPage = function (url, key, param) {
  if (common.isBaidu_swan()) {

    if (param) {
      swan.webView.reLaunch({
        url: url + common.serialize({
          [key]: param
        })
      })

      // swan.makePhoneCall({
      //     phoneNumber: '13716321443'
      // })

      // swan.navigateToSmartProgram({
      //     appKey: "4VvF29wlVg61mjRYCp4tY5dqkBgOyoYN",
      //     path: "/pages/union/proxy/proxy?spreadUrl=" + encodeURIComponent("https://u.jd.com/un4QNi")
      // })
    } else {
      swan.webView.reLaunch({
        url: url
      })
    }
  } else {

    if (param) {
      wx.miniProgram.reLaunch({
        url: url + common.serialize({
          _t: Date.now(),
          /* 本次消息的唯一编码，用于微信小程序将处理结果反馈给H5 */
          cmd: 'do',
          /* 业务指令 */
          [key]: param
        })
      })
    } else {
      wx.miniProgram.reLaunch({
        url: url
      })
    }
  }
}

/**
 * 小程序回退
 */
common.navigateBack = function () {
  if (common.isBaidu_swan()) {
    swan.webView.navigateBack()
  } else {
    wx.miniProgram.navigateBack()
  }
}

common.serialize = function (data) {
  let s = ''
  for (let p in data)
    s += '&' + p + '=' + encodeURIComponent(data[p]).replace(/\+/gm, '%2B')
  s = s.length > 0 ? s.substring(1) : s
  return s
}

/**
 * 是否群主, 通过userType判断
 */
common.isChanneler = function () {
  if (store.state.userType > -2) {
    return true
  } else {
    return false
  }
}

/**
 * 是群主并不在二级域名下，显示详情
 */
common.showSkuCommission = function () {
  if (!common.isClient_whole() && common.isChanneler()) {
    return true
  } else {
    return false
  }
}

common.getPid = function () {

  if (common.isClient_whole()) {
    return store.state.channel_pid
  } else {
    if (store.state.pid) {
      return store.state.pid
    } else if (store.state.channel_pid) {
      return store.state.channel_pid
    } else {
      return null
    }
    // return store.state.pid;
  }
}

common.getUsername = function () {

  if (common.isClient_whole()) {
    return store.state.channel_username
  } else {
    // return store.state.username;
    if (store.state.username) {
      return store.state.username
    } else if (store.state.channel_username) {
      return store.state.channel_username
    } else {
      return null
    }
  }
}

//判断是否是二级页面
common.isClient = function () {
  if (config.project === 'client') {
    return true
  } else {
    // return false;
    let _channel_name = common.getUrlKey('channel_name')
    if (_channel_name) {
      return true
    } else {
      return false
    }
  }
}

//判断是否是hm的二级页面
common.isClient_hm = function () {
  if (config.project === 'client_hm') {
    return true
  } else {
    return false
  }
}

//整体判断，是否是二级页面
common.isClient_whole = function () {
  if (common.isClient() || common.isClient_hm()) {
    return true
  } else {
    return false
  }
}

/**
 * 获取当天日期
 */
common.getTodayDate = function () {
  return common.dateFmt('yyyy-MM-dd', new Date())
}

/**
 * 提交商品内容到发品机器人时生成的id
 */
common.getSidToRobot = function (_skuId) {
  return md5(store.state.username + _skuId + common.getTodayDate()).toUpperCase()
}

//整体判断，是否显示淘宝
common.canShowTaobao = function () {
  //$config.project === 'jd_test' && $config.project !== 'mini' && $common_tb.getTaobaoPid() && !$common.is_weixn()
  if (!common.is_weixn()) {
    if (config.project === 'jd' || config.project === 'jd_test' || store.state.channel_tb_pid) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

common.canShowTaobao_data = function () {
  //$config.project === 'jd_test' && $config.project !== 'mini' && $common_tb.getTaobaoPid() && !$common.is_weixn()
  if (config.project === 'jd' || config.project === 'jd_test' || config.project === 'mini') {
    // if (!common.is_weixn() && config.project === 'jd_test') {
    return true
  } else {
    return false
  }
}

//整体判断，是否显示拼多多
common.canShowPdd = function () {

  // if(!common.is_weixn() && config.project === 'jd_test' && store.state.pid){
  // if (config.project !== 'hm' && !common.isClient_whole()) {
  if (config.project !== 'hm' || store.state.channel_pdd_pid) {
    return true
  } else {
    return false
  }
}

//是否显示美团
common.canShowMt = function () {
  if (config.project === 'jd_test') {
    return true
  } else {
    return false
  }
}

/**
 * 判断时间compare_date_str是否在start_date_str和end_date_str之间
 */
common.isInLimitTime = function (compare_date_str, start_date_str, end_date_str) {
  ////限制时间的开始data(2020-1-1)
  let startDate = common.stringToDate(start_date_str)
  //限制时间的结束data(2020-4-30)
  let endDate = new Date(common.stringToDate(end_date_str).getTime() + 24 * 60 * 60 * 1000 - 1)

  //需要判断的时间
  let compare_date = common.stringToDate(compare_date_str)

  if (compare_date > startDate && compare_date < endDate) {
    return true
  } else {
    return false
  }
}

/**
 * 时间取值，取到分钟
 * @param time_str
 * @returns {string}
 */
common.retainTimeMinute = function (time_str) {
  if (time_str && time_str.indexOf(':') !== -1) {
    let time = time_str.substring(0, time_str.indexOf(':', time_str.indexOf(':') + 1))
    return time
  }
  return ''
}

/**
 * 判断是否是在微信小程序
 * @returns {boolean}
 */
common.isWx_mini = function () {
  let UA = window.navigator.userAgent

  let regex = /miniProgram/
  //若为true，则是在小程序的web-view中打开
  return regex.test(UA)
}

/**
 * 判断是否是在百度小程序
 * @returns {boolean}
 */
common.isBaidu_swan = function () {
  let UA = window.navigator.userAgent
  let regex = /swan\//
  //若为true，则是在小程序的web-view中打开
  return regex.test(UA)
}

/**
 * 敏感词
 */
common.getSensitiveWords = function () {
  return ['口罩', '酒精', '疫情', '疫情严重', '新型肺炎',
    '新型冠状病毒', '武汉', '封城', '封路', '封村', '红十字会',
    '病毒感染', '疑似病例', '确诊病例', '钟南山', '卫健委',
    '国家卫生健康委员会', '隔离', '中国梦', '人类毁灭', '阴谋论',
    '捐款', '点击领奖', '恭喜领奖', '领取奖品', '抢爆', '再不抢就没了',
    '不会再便宜了', '国家级产品', '中奖', '免费', '关注',
    '关注公众号', '抽奖', '开奖', '裂变', '红包', '押注', '吸粉',
    '加粉', '增粉', '涨粉', '爆粉', '赚钱', '互粉', '腐败', '李文亮',
    '沙地红', '万好评', '手机号', '佣金', '荭苞', '机器人'
  ]
}

/**
 * 是否还有敏感词
 * @param str
 * @returns {boolean}
 */
common.hasSensitiveWords = function (str) {
  if (str) {
    let _message = '商品内容包含敏感词：“temp_sensitive_word”，' +
      '无法通过助理自动发品。\n\n可通过[图文推广]或[制作海报]手动分享产品到微信群。'
    let sensitive_words = common.getSensitiveWords()

    if (sensitive_words && sensitive_words.length > 0) {
      for (let i = 0; i < sensitive_words.length; i++) {
        if (str.indexOf(sensitive_words[i]) !== -1) {

          //包含敏感词
          Dialog.alert({
            title: '加入助理失败',
            message: _message.replace('temp_sensitive_word', sensitive_words[i]),
            messageAlign: 'left',
          })
          return true
        }
      }
    }

    // if(sensitive_words && sensitive_words.indexOf(",") !== -1){
    //     let sensitive_arr = sensitive_words.split(",");
    //     for(let i = 0; i < sensitive_arr.length; i++){
    //         if(str.indexOf(sensitive_arr[i]) !== -1){
    //
    //             //包含敏感词
    //             Dialog.alert({
    //                 title: "加入助理失败",
    //                 message: _message.replace('temp_sensitive_word', sensitive_arr[i])
    //             });
    //             return true;
    //         }
    //     }
    // }else{
    //     if(str.indexOf(sensitive_words) !== -1){
    //         //包含敏感词
    //         Dialog.alert({
    //             title: "加入助理失败",
    //             message: _message.replace('temp_sensitive_word', sensitive_words)
    //         });
    //         return true;
    //     }
    // }

  }

  return false
}

/**
 * 判断 check_data
 * @param check_data 待校验字符串或数值
 * @returns {boolean}
 */
common.isNumber = function (check_data) {
  return !isNaN(check_data)
}

common.hasWxUserInfo_mini = function () {
  if (common.gloabl_wx_mini_user_info && common.gloabl_wx_mini_user_info.nickname && common.gloabl_wx_mini_user_info.headimgurl) {
    return true
  } else {
    return false
  }
}

common.hasWxUserInfo_public = function () {
  if (store.state.wx_img && store.state.wx_img !== 'null' && store.state.wx_name && store.state.wx_name !== 'null') {
    return true
  } else {
    return false
  }
}

//自定义UI中用于判断 wx_hide
common.isShowComponent = function (_data) {
  let flg = true
  if (_data && _data.props) {
    if (_data.props.wx_hide === true) {
      if (common.is_weixn() || common.isWx_mini() || config.project === 'mini') {
        flg = false
      }
    }
    if (flg && _data.props.hidden !== true) {
      flg = true
    } else {
      flg = false
    }
  }
  return flg
}

// common.all_limit_words = [];
common.all_limit_words = ['会员', '手机卡', '充值卡', '腾讯', '爱奇艺', '优酷', '芒果TV', 'Q币', 'VIP'
  , '账号', '移动', '联通', '电信', '电话卡', '电子书', '网盘', '音乐', '电影', '网课', '点卡', '号码'
  , '充值', '网络电话', '序列号', '虚拟', '教材', '源码', '代码', '教材', '软件', 'APP', '资源', '培训'
  , '养殖', '技术', '破解', '下载', '录制', '课程',]

export default common